<div class="container" *ngIf="item">
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin-bottom: 1.5rem;">
    <div>
      <h1 style="margin: 0; font-size: 2.2rem; font-weight: 700; color: #146161;">
        <span *ngIf="item.tenant" style="background: #e0f7fa; color: #00796b; border-radius: 4px; padding: 0.2em 0.6em; margin-right: 0.5em; font-size: 1.1rem;">
          Direkte Anfrage
        </span>
        <span *ngIf="!item.tenant">Anfrage</span>
        <span style="color: #888; font-size: 1.2rem; font-weight: 400;">#{{item.id}}</span>
      </h1>
    </div>

    <a mat-flat-button color="primary"
      href="{{environment.apiDomain}}/admin/accounts/movlineinquiry/{{item.id}}/change/"
      target="_blank"
      style="font-weight: 600; letter-spacing: 0.5px;">
      <mat-icon style="margin-right: 0.4em;">edit</mat-icon>
      Bearbeiten
    </a>
  </div>

  <div class="alert alert-warning" role="alert" style="width: 100%" *ngIf="item.tenant">
      Direkte Anfrage an <a routerLink="/main/admin/organizations/{{item.tenant}}">Partner firma</a>
  </div>

</div>

<app-inquiry-details-card [item]="item"></app-inquiry-details-card>

<div class="container" *ngIf="item">
  <div *ngIf="item" class="mt-5 admin-inquiry-warning" style="border: solid 1px red; padding: 8px;">
    <div class="alert alert-warning">ADMIN Area (nicht einsehbar für "normalen Firmen")</div>
    <div class="alert alert-info">Status: {{item.status | inquiryStatusPipe}}</div>

    <a *ngIf="item.status==inquiryStatus.WAITING_FOR_ACCEPTANCE"
      class="modern-btn preview-link"
      href="{{environment.uiDomain}}/choose-offer?tk={{item.uuid}}" 
      target="_blank"
      style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white; margin-bottom: 1rem; display: inline-flex; align-items: center; text-decoration: none; border-radius: 8px; padding: 12px 20px; font-weight: 600; box-shadow: 0 4px 15px rgba(0,0,0,0.2); transition: all 0.3s ease;">
      Kundenansicht öffnen
      <mat-icon style="margin-left: 0.6em; font-size: 18px;">open_in_new</mat-icon>
    </a>

    <h5>Actions</h5>
    <div class="co-buttons-list">
      <button mat-icon-button color="primary" (click)="onEditInquiry()" matTooltip="Bearbeiten">
        <mat-icon>edit</mat-icon>
      </button>

      <button mat-icon-button color="primary" (click)="onEditInventory()" matTooltip="Inventar Bearbeiten">
        <mat-icon>inventory_2</mat-icon>
      </button>

      <button mat-icon-button color="primary" (click)="refresh()" matTooltip="Aktualisieren">
        <mat-icon>refresh</mat-icon>
      </button>

      <button mat-icon-button color="warn" (click)="onAdminReleaseInquiry()" 
              *ngIf="item?.status==inquiryStatus.OPEN" 
              matTooltip="Angebotsrunde öffnen">
        <mat-icon>lock_open</mat-icon>
      </button>

      <button mat-icon-button color="warn" (click)="onAdminReleaseToInquirer()" 
              *ngIf="item?.status==inquiryStatus.OPEN_FOR_BIDS" 
              matTooltip="Angebotsrunde abschliessen">
        <mat-icon>lock</mat-icon>
      </button>

      <button mat-icon-button color="accent" (click)="onAdminDeleteInquiry()" 
              matTooltip="Löschen" 
              aria-label="Löschen">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <br>
    <br>

    <div *ngIf="item">
      <h5>Angebote</h5>
      <div *ngIf="!!item && item.offer_objects && item.offer_objects.length" class="modern-inventory-table responsive-offers-table" style="margin-top: 1em;">
        <div class="modern-inventory-header">
          <div class="modern-inventory-col col-company">
            <mat-icon matTooltip="Firma" class="desktop-only">business</mat-icon>
            <span class="mobile-only">Firma</span>
          </div>
          <div class="modern-inventory-col col-date">
            <mat-icon matTooltip="Datum" class="desktop-only">event</mat-icon>
            <span class="mobile-only">Datum</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Umzugspreis" class="desktop-only">local_shipping</mat-icon>
            <span class="mobile-only">Umzug</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Ab- und Aufbau" class="desktop-only">build</mat-icon>
            <span class="mobile-only">Montage</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Reinigung" class="desktop-only">cleaning_services</mat-icon>
            <span class="mobile-only">Reinigung</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Entsorgung pro m3" class="desktop-only">delete</mat-icon>
            <span class="mobile-only">Entsorgung</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Lampenmontage" class="desktop-only">lightbulb</mat-icon>
            <span class="mobile-only">Lampen</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Floorliner" class="desktop-only">layers</mat-icon>
            <span class="mobile-only">Floorliner</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Kisten einpacken" class="desktop-only">inventory_2</mat-icon>
            <span class="mobile-only">Kisten</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Kleiderboxenmiete" class="desktop-only">checkroom</mat-icon>
            <span class="mobile-only">Kleiderboxen</span>
          </div>
          <div class="modern-inventory-col col-price">
            <mat-icon matTooltip="Möbellift" class="desktop-only">elevator</mat-icon>
            <span class="mobile-only">Möbellift</span>
          </div>
          <div class="modern-inventory-col col-actions">
            <span></span>
          </div>
        </div>
        <div class="modern-inventory-row" *ngFor="let offer of item.offer_objects">
          <div class="modern-inventory-col col-company">
            <span class="mobile-label">Firma:</span>
            <span class="table-value">{{offer.organization_object.name}}</span>
          </div>
          <div class="modern-inventory-col col-date">
            <span class="mobile-label">Datum:</span>
            <span class="table-value">{{offer.updated_at | humanDatePipe}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Umzug:</span>
            <span class="table-value">{{offer.price_move | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Montage:</span>
            <span class="table-value">{{offer.price_montage | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Reinigung:</span>
            <span class="table-value">{{offer.price_cleaning | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Entsorgung:</span>
            <span class="table-value">{{offer.price_disposal | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Lampen:</span>
            <span class="table-value">{{offer.price_service_mount_lamps | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Floorliner:</span>
            <span class="table-value">{{offer.price_service_floorliner | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Kisten:</span>
            <span class="table-value">{{offer.price_service_boxes | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Kleiderboxen:</span>
            <span class="table-value">{{offer.price_services_clothes_boxes | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-price">
            <span class="mobile-label">Möbellift:</span>
            <span class="table-value">{{offer.price_services_furniture_lift | thousandsSeparator}}</span>
          </div>
          <div class="modern-inventory-col col-actions">
            <span class="mobile-label">Aktionen:</span>
            <div class="co-buttons-list">
              <a mat-icon-button color="primary" 
                href="{{environment.apiDomain}}/admin/accounts/movlineoffer/{{offer.id}}/change/" 
                target="_blank"
                matTooltip="Bearbeiten">
                <mat-icon>edit</mat-icon>
              </a>
              <button mat-icon-button color="accent" 
                      (click)="onAdminDeleteOffer(offer.uuid)"
                      matTooltip="Löschen">
                <mat-icon>restore_from_trash</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!!item && item.offer_objects && item.offer_objects.length == 0" style="width: 100%">
        Noch keine Gebote
      </div>
      <hr>

      <h5>Kontaktdetails</h5>
      <mat-card class="mt-3">
        <mat-card-content>
          <div class="dotted-info-row">
            <span class="dotted-label">E-Mail:</span>
            <span class="dotted-fill"></span>
            <span class="dotted-value">{{item.email}}</span>
          </div>
          <div class="dotted-info-row">
            <span class="dotted-label">Anrede:</span>
            <span class="dotted-fill"></span>
            <span class="dotted-value">{{item.gender}}</span>
          </div>
          <div class="dotted-info-row">
            <span class="dotted-label">Vorname:</span>
            <span class="dotted-fill"></span>
            <span class="dotted-value">{{item.first_name}}</span>
          </div>
          <div class="dotted-info-row">
            <span class="dotted-label">Nachname:</span>
            <span class="dotted-fill"></span>
            <span class="dotted-value">{{item.last_name}}</span>
          </div>
          <div class="dotted-info-row">
            <span class="dotted-label">Telefon:</span>
            <span class="dotted-fill"></span>
            <span class="dotted-value">{{item.phone || "-"}}</span>
          </div>
        </mat-card-content>
      </mat-card>
      <hr>

      <mat-card class="mt-3">
        <mat-card-content>
          <comments-card-component [title]="'Meine Anfragekommentare als Admin (für mich)'" [adminMode]="true"
            [public]="false" [entityUUID]="this.item.uuid"></comments-card-component>
        </mat-card-content>
      </mat-card>

      <hr>
      <mat-card class="mt-3">
        <mat-card-content>
          <comments-card-component [title]="'Meine Anfragekommentare als Admin (für alle)'" [adminMode]="true"
            [public]="true" [entityUUID]="this.item.uuid"></comments-card-component>
        </mat-card-content>
      </mat-card>
    </div>

  </div>

  <pre *ngIf="environment.envName == 'local_dev'">
    {{item | json}}
  </pre>


</div>
